// Where the user was headed before we bounced them to login. Held in
// sessionStorage so a reload on the login screen doesn't lose it.
const ROUTE_TO_KEY = 'connect2_route_to'

export const readRouteTo = () => {
    try {
        return JSON.parse(sessionStorage.getItem(ROUTE_TO_KEY)) || {}
    } catch (e) {
        return {}
    }
}

export const writeRouteTo = (routeTo) => {
    try {
        sessionStorage.setItem(ROUTE_TO_KEY, JSON.stringify(routeTo || {}))
    } catch (e) {
        // storage unavailable, in-memory only
    }
}

export default {
    loggedIn: true,
    loginEmail: '',
    staffTotal: 0,
    isStaffFirstView: true,
    isDocumentsFirstView: true,
    isAccreditationFirstView: true,
    docsTotal: 0,
    practiceId: '',
    staticChoices: {},
    listFilter: {
        limit: 25,
        offset: 0,
        pageSize: 25,
        currentPage: 0,
        searchVal: '',
        columnFilters: {}
    },
    modal: {
        isVisible: false,
        componentName: 'ModalDefault',
        componentData: {},
    },
    permissions: {},
    routeTo: readRouteTo(),
    routeFrom: {},
    webinarLoginCode: '',
    webinarAccessObject: {},
    folders: [],
    getVisibleFolders: true
}
